import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const NavItem = ({ title, icon, yellow = false, onClick, className = '' }) => {
  return (
    <div
      className={`mb-8 text-center cursor-pointer rounded-lg p-3 transition-colors duration-200 hover:bg-gray-700 ${className}`}
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon={icon}
        className={`text-3xl ${yellow ? 'text-yellow-500' : ''}`}
      />
      <span className="font-semibold text-base block mt-1">{title}</span>
    </div>
  )
}

export default NavItem
